// utils/constants.js
// All constants extracted from Profile.js

// Process IDs
export const AO_PROCESS_ID = "Lz7YdBjzSZ2ZU1VCGxFm14urgTO9PvMJjXdPJ20B0H0";
export const SEND_TOKEN_PROCESS_ID = "O2mmX6O7ZNUnRfE8pYtzTT2uH55dXrvIR8YeaOEsp9I";

// API and App Config
export const API_URL = "https://api.dev.amportal.ai";
export const ARWEAVE_APP_NAME = "amPassport-Profile";


// Thresholds and Limits
export const AMPOINTS_THRESHOLD = 10000;
export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Animation Constants
export const SPRING_CONFIG = {
  type: "spring",
  stiffness: 400,
  damping: 30
} as const;

export const HOVER_SCALE = 1.02;
export const PRESS_SCALE = 0.98;

// Role Constants
export const COSMIC_ROLES = new Set([
   'amVerified',
  'GitHub Verified',
  'X Verified',
  'ArNS Holder',
  'OG Sender',
  'Beta-Tester',
  'Elite'
]);

// Activity Type Mapping
export const ACTIVITY_TYPE_MAP = {
  'githubInteraction': 'GitHub Activity',
  'xInteraction': 'X Platform Post',
  'AIActivity': 'AI Interaction',
  'Discord': 'Discord Activity',
  'amVerified': 'Verification',
  'tip': 'Tip Transaction',
  'stake': 'Staking Activity',
  'gm': 'GM Streak',
  'gn': 'GN Streak',
  'sendit': 'SendIt Activity'
};

// Custom AO Configuration
export const CUSTOM_AO_CONFIG = {
  CU_URL: 'https://cu.ardrive.io',
};

// Custom Process Configuration
export const CUSTOM_PROCESS_CONFIG = {
  processId: 'qNvAoz0TgcH7DMg8BCVn8jF32QH5L6T29VjHxhHqqGE',
};